'use strict';

/**
 * Enum definition file for the allow-listed price tag value transforms.
 *
 * @module data/enums/price-tag-transforms
 */
module.exports = {
    loyaltyCustomerAvailability: 'loyaltyCustomerAvailability',
    limitUnitsToTriggers: 'limitUnitsToTriggers',
    tierCount: 'tierCount',
};
